/* Aggiunta dei layer tramite file */
import { useLeaflet } from "react-leaflet";
import { useEffect } from "react";
import { connect } from "react-redux";
import L from "leaflet";
import omnivore from '@mapbox/leaflet-omnivore'
import shp from "shpjs";
import 'leaflet-kmz'

const AddLayerFile = (props) => {
    const { map } = useLeaflet();
    

    // Funzione caricamento file in base al tipo
    function Load(file,tipoFile){
        
        var reader = new FileReader();
        
        reader.onload = function(){
            if (reader.readyState !== 2 || reader.error){
                return;
            } else {
                switch (tipoFile) {
                    case "KML":
                        LoadKML(reader.result)
                        break;
                    case "CSV":
                        
                        LoadCSV(reader.result)
                        break;
                    case "GeoJSON":
                        LoadGeoJSON(reader.result)
                        break;
                    case "KMZ":
                        handleKMZFile(reader.result)
                        break;
                    default:
                        break;
                }
                
            }
        }
        reader.readAsDataURL(file);
    }

    // Caricamento file KML
    function LoadKML(layer){
        var runLayer = omnivore.kml(layer)
            .on('ready', function() {
                try {
                    map.fitBounds(runLayer.getBounds());
                } catch (error) {  
                }
            })
        map.addLayer(runLayer)
    }

    // Caricamento file CSV
    function LoadCSV(layer){
        var runLayer = omnivore.csv(layer)
            .on('ready', function() {
            //     try {
            
            //     map.fitBounds(runLayer.getBounds());
            // } catch (error) {  
            // }
            })
            
        map.addLayer(runLayer)
    }

    // Caricamento file geoJson
    function LoadGeoJSON(layer){
        var runLayer = omnivore.geojson(layer)
            .on('ready', function() {
                try{
                    
                map.fitBounds(runLayer.getBounds());
            } catch (error) {  
            }
            })
            
        map.addLayer(runLayer)
    }
    function removeAllLayer(){
        map.eachLayer(element => {
           
              try { 
                //map.removeLayer(element)
                if(element._parts !== undefined){
                    map.removeLayer(element)
 
                }
                }
                catch(e) {}
            
        }); 
    }
        

    
    // Lettura di un file da uno zip
    function handleZipFile(file){
        
        var reader = new FileReader();
        reader.onload = function(){
            if (reader.readyState !== 2 || reader.error){
                return;
            } else {
                convertToLayer(reader.result);
            }
        }
        reader.readAsArrayBuffer(file);
    }

    // Caricamento file kmz  
    function handleKMZFile(file){
        var kmz = L.kmzLayer().addTo(map)
        kmz.load(file)
        }
    
    // Conversione del geoJson in layer
    function convertToLayer(buffer){
        shp(buffer).then(function(geojson){
            var layer =  L.geoJSON(geojson,{tag:props.layerFile.layerFile.file.name})
            
            
            map.addLayer(layer)
        });
    }

    function removeAllLayer(){
        map.eachLayer(element => {
            
              try { 
                //map.removeLayer(element)
                if(element._parts !== undefined){
                    

                    map.removeLayer(element)

                }
                }
                catch(e) {}
            
        }); 
    }
    function removeLayer(nome){
        
        
         map.eachLayer(element => {
            
            if ( element.options.tag === nome) {
              try { 
                map.removeLayer(element)
                }
                catch(e) {console.log(e)}
            }
        });  
    }

    useEffect(()=>{
        
        
        try {
            if (props.layerFile.layerFile.check === true ){
                
                
                if (props.layerFile.layerFile.type === "ShapeFile") {
                    handleZipFile(props.layerFile.layerFile.file);
                } else {
                    
                     Load(props.layerFile.layerFile.file, props.typeLayer.type)
                } 
               
                
            }else  {
                
                removeLayer(props.layerFile.layerFile.file.name)
            }
        } catch (error) {
              
        }

        
    },[props.layerFile])
   
    return null;
};

const mapStateToProps = state => {
    return {
        layerFile: state.layerFile,
        typeLayer: state.typeLayer.typeLayer
    }
  }
export default connect(mapStateToProps) (AddLayerFile)